import { sidebarMenu } from "../config/sidebarConfig";

const getMenuLabelForRoute = (pathname) => {
  for (const menu of sidebarMenu) {
    if (menu.route === pathname) return { menuLabel: menu.label, subLabel: null };
    if (menu.subMenu) {
      for (const sub of menu.subMenu) {
        if (sub.route === pathname) return { menuLabel: menu.label, subLabel: sub.label };
      }
    }
  }
  return null;
};

export const hasAccessToRoute = (user, pathname) => {
  // admin has access to everything
  if (!user || user.role === "admin") return true;

  // only restrict subadmin
  if (user.role !== "subadmin") return true;

  const accessTabs = user.access_tabs || [];
  const routeInfo = getMenuLabelForRoute(pathname);

  // route not in sidebar config, allow it
  if (!routeInfo) return true;

  const { menuLabel, subLabel } = routeInfo;

  const matchedTab = accessTabs.find((tab) => tab.name === menuLabel);

  // top level menu not in access_tabs
  if (!matchedTab) return false;

  // it's a submenu route, check submenu access
  if (subLabel) {
    const allowedSub = matchedTab.submenu || [];
    return allowedSub.some((s) => s.name === subLabel);
  }

  return true;
};